import React from 'react'
import * as S from './index.styles'
import { useSelector } from 'src/utils/store'

export const LastUpdated = ({ loading }) => {
  const { lastUpdatedInfo } = useSelector((state) => state.supplier)

  return (
    <S.Wrapper>
      <S.Icon $error={lastUpdatedInfo.error} $loading={loading} />
      {lastUpdatedInfo.dateOrMessage ? 'Ultima atualização: ' + lastUpdatedInfo.dateOrMessage : ''}
    </S.Wrapper>
  )
}
